import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import Button from '@Components/Button';
import { Checkbox } from '@els/els-react--checkbox';

import './UserAgreementPrompt.scss';

function UserAgreementPrompt({ selfClose, submit }) {
  const [isLicenseAgreement, setLicenseAgreement] = useState(false);

  const handleCheckboxChange = (e) => {
    setLicenseAgreement(e.target.checked);
  };

  const handleSubmit = () => {
    selfClose();
    submit();
  };

  return (
    <GeneralDialogLayout
      selfClose={selfClose}
      className="profile-settings-user-agreement-prompt"
      size="xl"
      layoutType="nothing"
      movable={false}
      closeBtn={false}
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      header={`Please note: you need to confirm that you agree with the "Registered User Agreement". Please check the following
      and click OK to proceed.`}
      footer={
        <>
          <Button
            onClick={selfClose}
            buttonConfig={{
              type: 'tertiary',
              className: 'profile-settings-user-agreement-prompt__button',
              size: 'sm',
              label: 'Cancel',
              e2eName: 'profile-settings-user-agreement-prompt-cancel',
            }}
            iconConfig={{
              name: 'delete',
              size: 'xs',
            }}
          />

          <Button
            disabled={!isLicenseAgreement}
            onClick={handleSubmit}
            buttonConfig={{
              type: 'tertiary',
              className: 'profile-settings-user-agreement-prompt__button',
              size: 'sm',
              label: 'Ok',
              e2eName: 'profile-settings-user-agreement-prompt-submit',
            }}
            iconConfig={{
              name: 'chevron-right',
              size: 'xs',
            }}
          />
        </>
      }>
      <div className="els-text-input els-checkbox-input">
        <div className="profile-settings-user-agreement-prompt__checkbox">
          <Checkbox
            checked={isLicenseAgreement}
            id="profile-settings-user-agreement-prompt_checkbox"
            onChange={handleCheckboxChange}
            label="I have read and agree to the Registered User Agreement"
            shouldHideLabel
          />
          <div className=" ">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="profile-settings-user-agreement-prompt_checkbox" title="I agree to the Registered User Agreement">
              <span>
                I have read and agree to the
                <a
                  className="u-els-color-link-inline profile-settings-user-agreement-prompt__checkbox_link"
                  target="_blank"
                  href="https://www.elsevier.com/useragreement?dgcid=RN_AGCM_Sourced_300005028"
                  rel="noreferrer">
                  Registered User Agreement
                </a>
              </span>
            </label>
          </div>
        </div>
      </div>
    </GeneralDialogLayout>
  );
}

UserAgreementPrompt.propTypes = {
  selfClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default UserAgreementPrompt;
